// src/components/HeroSection/HeroSection.jsx
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import "./HeroSection.css";

export default function HeroSection() {
  const [heroImageUrl, setHeroImageUrl] = useState(null);


  useEffect(() => {
    const fetchHeroImage = async () => {
      try {
        const docRef = doc(db, "settings", "heroImage");
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const { url } = snap.data();
          if (url) setHeroImageUrl(url);
        }
      } catch (err) {
        console.error("Failed to load hero image from Firestore:", err);
      }
    };

    fetchHeroImage();
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-content">
        <motion.div
          className="hero-text"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h1 className="hero-title">Where Golden Retrievers Begin Their Journey Home</h1>
          <p className="hero-description">
            At <strong>DeClerck’s Goldens</strong>, we do more than raise golden retrievers. We raise lifelong companions.
            Our <strong>AKC registered puppies</strong> grow up in the heart of our family in <strong>Albion, NY</strong>,
            surrounded by love, socialized from the start, and prepared to become a joyful part of your life.
          </p>

          <div className="hero-cta-wrapper">
            <Link to="/puppies" className="hero-cta">
              Meet Your Puppy
            </Link>
          </div>

          <div className="seal-row">
            <img src="/seals/AKC Seal.png" alt="AKC Registered" className="seal" />
            <img src="/seals/NYAG Seal.png" alt="NY Licensed" className="seal" />
            <img src="/seals/OFA Seal.png" alt="OFA Screened" className="seal" />
            <img src="/seals/HG Seal.png" alt="Health Guarantee" className="seal" />
          </div>
        </motion.div>

        {heroImageUrl && (
        <motion.div
          className="hero-image"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
        >
          <img
            src={heroImageUrl}
            alt="Golden retrievers in a grassy field"
          />
        </motion.div>
      )}

      </div>
    </section>
  );
}
